export const clickEvent = (ev, id) => {
  ev.preventDefault();
  const el = document.querySelector("#scroller");
  const to = el.querySelector(id);
  el.scrollTop = to.offsetTop - 96;
};
